/* Shirayuki: interaction layer ported from the original site's script.js
   (scroll reveal, counters, hero glow, testimonial slider, product filter chips, mobile menu). */
document.documentElement.classList.add('k-js');

function kInit(root) {
  /* Mobile menu */
  const toggle = root.querySelector('.k-nav-toggle');
  const mobile = root.querySelector('.k-nav-links-mobile');
  if (toggle && mobile && !toggle.dataset.kBound) {
    toggle.dataset.kBound = '1';
    toggle.addEventListener('click', () => {
      const open = mobile.classList.toggle('k-open');
      toggle.classList.toggle('k-open', open);
      toggle.setAttribute('aria-expanded', open);
      const bars = toggle.querySelectorAll('span');
      bars[0].style.transform = open ? 'translateY(6px) rotate(45deg)' : '';
      bars[1].style.opacity = open ? '0' : '';
      bars[2].style.transform = open ? 'translateY(-6px) rotate(-45deg)' : '';
    });
  }

  /* Scroll reveal */
  const revealEls = root.querySelectorAll('.k-reveal:not(.k-is-visible), .k-reveal-scale:not(.k-is-visible), .k-line-draw:not(.k-is-visible)');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('k-is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('k-is-visible'));
  }

  /* Animated counters */
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseFloat(el.dataset.count);
      const suffix = el.dataset.suffix || '';
      const start = performance.now();
      function tick(now) {
        const progress = Math.min((now - start) / 1600, 1);
        const value = target * (1 - Math.pow(1 - progress, 3));
        el.textContent = (target % 1 === 0 ? Math.floor(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      counterIO.unobserve(el);
    });
  }, { threshold: 0.6 });
  root.querySelectorAll('[data-count]').forEach((el) => counterIO.observe(el));

  /* Hero cursor-follow glow */
  const hero = root.querySelector('.k-hero');
  const glow = root.querySelector('.k-hero-glow');
  if (hero && glow) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      glow.style.transform = `translate(${e.clientX - rect.left - 240}px, ${e.clientY - rect.top - 240}px)`;
    });
  }

  /* Testimonial slider */
  const slider = root.querySelector('.k-t-slider');
  if (slider) {
    const slides = slider.querySelectorAll('.k-t-slide');
    const dotsWrap = root.querySelector('.k-t-dots');
    let current = 0;
    const show = (i) => {
      slides[current].style.opacity = '0';
      slides[current].style.pointerEvents = 'none';
      current = (i + slides.length) % slides.length;
      slides[current].style.opacity = '1';
      slides[current].style.pointerEvents = 'auto';
      if (dotsWrap) dotsWrap.querySelectorAll('.k-chip').forEach((d, idx) => d.classList.toggle('k-active', idx === current));
    };
    if (dotsWrap) dotsWrap.innerHTML = '';
    slides.forEach((s, i) => {
      if (dotsWrap) {
        const dot = document.createElement('button');
        dot.className = 'k-chip' + (i === 0 ? ' k-active' : '');
        dot.textContent = String(i + 1).padStart(2, '0');
        dot.addEventListener('click', () => show(i));
        dotsWrap.appendChild(dot);
      }
      s.style.transition = 'opacity 0.6s ease';
      if (i !== 0) { s.style.opacity = '0'; s.style.pointerEvents = 'none'; }
    });
    root.querySelectorAll('[data-t-next]').forEach((b) => b.addEventListener('click', () => show(current + 1)));
    root.querySelectorAll('[data-t-prev]').forEach((b) => b.addEventListener('click', () => show(current - 1)));
    setInterval(() => show(current + 1), 6000);
  }

  /* Product filter chips */
  const chips = root.querySelectorAll('[data-filter]');
  const products = root.querySelectorAll('[data-category]');
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach((c) => c.classList.remove('k-active'));
      chip.classList.add('k-active');
      const filter = chip.dataset.filter;
      /* hide non-matching cards at once (no delayed removal, so the grid never jumps),
         then fade the matching cards in where they finally sit */
      products.forEach((p) => {
        const show = filter === 'all' || p.dataset.category === filter;
        p.style.transition = 'none';
        if (show) {
          p.style.display = '';
          p.style.opacity = '0';
          p.style.transform = 'translateY(8px)';
        } else {
          p.style.display = 'none';
        }
      });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        products.forEach((p) => {
          if (p.style.display === 'none') return;
          p.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          p.style.opacity = '1';
          p.style.transform = 'none';
        });
      }));
      /* Nichijō page: swap the green header to the chosen line */
      if (chip.dataset.headTitle) {
        const head = root.querySelector('[data-k-head="title"]')?.closest('header');
        if (head) {
          head.classList.add('k-head--swap');
          setTimeout(() => {
            for (const key of ['eyebrow', 'title', 'kanji', 'lead']) {
              const el = head.querySelector('[data-k-head="' + key + '"]');
              const val = chip.dataset['head' + key[0].toUpperCase() + key.slice(1)];
              if (el && val != null) el.textContent = val;
            }
            head.classList.remove('k-head--swap');
          }, 300);
        }
      }
      const empty = root.querySelector('[data-k-empty]');
      if (empty) empty.hidden = [...products].some((p) => filter === 'all' || p.dataset.category === filter);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => kInit(document));
} else {
  kInit(document);
}
/* Re-run when a section is re-rendered in the theme editor */
document.addEventListener('shopify:section:load', (e) => kInit(e.target));
